import get from "lodash/get";
import {
    deleteInvoiceClientLoading,
    deleteInvoiceClientReject,
    deleteInvoiceClientRequest,
    deleteInvoiceClientSuccess,
    deleteInvoiceClientReset,
} from "../../actions/invoiceClient/delete";

export const deleteInvoiceClient = (InvoiceId) => async (dispatch, getState) => {
    dispatch(deleteInvoiceClientLoading());
    try {
        const { data } = await deleteInvoiceClientRequest({ InvoiceId }, getState);
        dispatch(deleteInvoiceClientSuccess(data));
    } catch (error) {
        dispatch(deleteInvoiceClientReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(deleteInvoiceClientReset()); }, 3000);
    }
    return Promise.resolve();
};
